import Indyra from '../Assets/Images/indrya-mokeup.avif';
import IndyraLogo from '../Assets/Images/indyra-logo.avif';
import Bigkheti from '../Assets/Images/bigkheti-mokeup.avif';
import BigkhetiLogo from '../Assets/Images/big-kheti-logo.avif';
import Spacetruck from '../Assets/Images/spacetruck-mokeup.avif';
import SpacetruckLogo from '../Assets/Images/space-truck-logo.avif';
import Kidsacademy from '../Assets/Images/kidsacademy-mokeup.avif';
import KidsacademyLogo from '../Assets/Images/kids-academy-logo.avif';
import Capitalcalc from '../Assets/Images/capitalcalc-mokeup.avif';
import CapitalcalcLogo from '../Assets/Images/capital-cals-logo.avif';
import Assistree from '../Assets/Images/assitree-mokeup.avif';
import AssistreeLogo from '../Assets/Images/assistree-logo.avif';
import Greenlab from '../Assets/Images/greenlab-mokeup.avif';
import GreenlabLogo from '../Assets/Images/greenlab-logo.avif';
import IngridoOption from '../Assets/Images/ingridoopinion-mokeup.avif';
import IngridoOptionLogo from '../Assets/Images/ingrido-opion-logo.avif';
import Koomz from '../Assets/Images/koomz-mokeup.avif';
import KoomzLogo from '../Assets/Images/koomz-logo.avif';
import MySociety from '../Assets/Images/my-society-mokeup.avif';
import MysocietyLogo from '../Assets/Images/my-society-logo.avif';
import CupcakeCastle from '../Assets/Images/cupcake-castle-mokeup.avif';
import CupcakeCastleLogo from '../Assets/Images/cupcake-castles-logo.avif';
import Doulamatch from '../Assets/Images/doula-match-mokeup.avif';
import DoulamatchLogo from '../Assets/Images/doula-match-logo.avif';
import Neurofenix from '../Assets/Images/neurofenix-mokeup.avif';
import NeurofenixLogo from '../Assets/Images/neurofix-logo.avif';
import Airwe from '../Assets/Images/air-we-mokeup.avif';
import AirweLogo from '../Assets/Images/air-we-logo.avif';
import { CONSTANT } from './Constant';

export const AgenciesList = [
  {
    id: 1,
    logo: IndyraLogo,
    imgUrl: Indyra,
    keyword: `${`Indyra Project | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`}`
  },
  {
    id: 2,
    logo: BigkhetiLogo,
    imgUrl: Bigkheti,
    keyword: `${`Bigkheti Project | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`}`
  },
  {
    id: 3,
    logo: SpacetruckLogo,
    imgUrl: Spacetruck,
    keyword: `${`Spacetruck Project | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`}`
  },
  {
    id: 4,
    logo: KidsacademyLogo,
    imgUrl: Kidsacademy,
    keyword: `${`Kidsacademy Project | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`}`
  },
  {
    id: 5,
    logo: CapitalcalcLogo,
    imgUrl: Capitalcalc,
    keyword: `${`Capitalcalc Project | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`}`
  },
  {
    id: 6,
    logo: AssistreeLogo,
    imgUrl: Assistree,
    keyword: `${`Assistree Project | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`}`
  },
  {
    id: 7,
    logo: GreenlabLogo,
    imgUrl: Greenlab,
    keyword: `${`Greenlab Project | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`}`
  },
  {
    id: 8,
    logo: IngridoOptionLogo,
    imgUrl: IngridoOption,
    keyword: `${`IngridoOption Project | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`}`
  },
  {
    id: 9,
    logo: KoomzLogo,
    imgUrl: Koomz,
    keyword: `${`Koomz Project | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`}`
  },
  {
    id: 10,
    logo: MysocietyLogo,
    imgUrl: MySociety,
    keyword: `${`MySociety Project | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`}`
  },
  {
    id: 11,
    logo: CupcakeCastleLogo,
    imgUrl: CupcakeCastle,
    keyword: `${`CupcakeCastle Project | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`}`
  },
  {
    id: 12,
    logo: DoulamatchLogo,
    imgUrl: Doulamatch,
    keyword: `${`Doulamatch Project | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`}`
  },
  {
    id: 13,
    logo: NeurofenixLogo,
    imgUrl: Neurofenix,
    keyword: `${`Neurofenix Project | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`}`
  },
  {
    id: 14,
    logo: AirweLogo,
    imgUrl: Airwe,
    keyword: `${`Airwe Project | ${CONSTANT.PIXERFECT_SOLUTIONS_LLP}`}`
  }
];
